import {useEffect, useState} from "react"
import {Card, Col, Row} from "react-bootstrap";
import {UsePost, UsePut} from "../../hooks/http";
import {UseMessage} from "../../hooks/UseMessage";
import Form from "./Form";


const Edit = ({id}) => {


    const [role, setRole] = useState()
    const [errors, setErrors] = useState()
    const [permissions, setPermissions] = useState()
    const [isLoading, setIsLoading] = useState(true)


    const GetEntities = async () => {
        const requestRole = await UsePut(
            `/roles/get/${id}`,
            {data: {limit: 1, offset: 0, _id: id}}
        )

        const requestPermissions = await UsePut(
            `/permissions/get`,
            {data: {offset: 0}, toArray: true, propLabel: 'name'}
        )

        return {
            role    : requestRole?.entities[0],
            permissions: requestPermissions
        }
    }


    useEffect(() => {
        GetEntities().then((response) => {
            setRole(response.role)
            setPermissions(response.permissions)
            setIsLoading(false)
        })
    }, [])


    const handleUpdate = (PostData) => {
        setIsLoading(true)
        UsePost(
            `/roles/upsert/${id}`,
            {data: PostData}
        ).then((response) => {
            window.setTimeout(() => {
                if (response.code >= 200 && response.code <= 299) {
                    UseMessage('success', 'Role has been successfully updated')
                } else {
                    setErrors(response.errors)
                }
                setIsLoading(false)
            }, 1500)
        })
    }


    return (
        <>
            <Card>
                <Row>
                    <Col>
                        <div className="max-width-600">
                            <Form role={role} permissions={permissions} errors={errors} isReady={!isLoading} onSubmit={handleUpdate}/>
                        </div>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export default Edit